import './App.css';
import { useNavigate } from 'react-router-dom';
import { Message } from './components';
import { useEffect, useState } from 'react';
import Icon, { AppstoreOutlined, MailOutlined, MenuOutlined, SettingOutlined } from '@ant-design/icons';
import { Drawer, Menu, Switch } from 'antd';
import { getEnterpriseInfo } from './Functions';

export var menu = 
              [ 
                { title: 'Movimenti', path:'/movements', icon: '' },
                { title: 'Azienda',     path:'/company',    icon: '' },
                { title: 'Punto vendita',     path:'/stores',    icon: '' },
                { title: 'Operatori', path:'/operators', icon: '' },
                { title: 'Fornitori', path:'/suppliers', icon: '' },
                { title: 'Causali',   path:'/reasons',   icon: '' },
                { title: 'LogOut',    path:'/',   icon: '' },
              ]


export const usePreventScrollRefresh = () => {
  useEffect(() => {
    const handleScroll = (event) => {
      if (window.scrollY > 100) {
        event.preventDefault();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
};




function Dash() {
  const navigate = useNavigate();
  const [openMessage, setOpenMessage] = useState(false);
  const [message, setMessage]         = useState('');
  const [openDrawer, setOpenDrawer]   = useState(false)

  const register = values => {
    try{


    }catch( err ){
      console.log(err);
    }
  }
  


  return (
    <div className="center bg-color-primary all-viewport">
      {
         Message( message, openMessage, ()=> setOpenMessage(false))
      }
      <div onClick={()=> setOpenDrawer(true)} style={{position:'fixed', top: '10px', left:'10px'}}>
        <MenuOutlined style={{fontSize:'30px'}} />
      </div>
      <Drawer
        className='bg-color-secondary'
        placement='left'
        open={openDrawer}
        onClose={()=> setOpenDrawer(false)}
      >
        <div style={{height:'100%', width: '100%', overflowY: 'auto'}}>
          {
            menu.map((m) => <div 
            onClick={() => {
               navigate(m.path);
              }}
            style={{ height:'50px', fontSize:'20px', fontWeight:'bold', cursor:'pointer' }} 
            
            > {m.title} </div>)
          }

        </div>

      </Drawer>

    </div>
  );
}

export default Dash;
